module.exports = __webpack_public_path__ + "static/media/seppuku-sudoku.12bf2f4e.png";